import React, { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc, collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import Navbar from '../components/navBar';
import Footer from '../components/footer';
import AllProducts from '../components/AllProducts';
import BottomBar from '../components/BottomBar';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const Product = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [instaID, setInstaID] = useState('');
  const [currency, setcurrency] = useState('');
  const [whsappID, setwhsappID] = useState('');
  const [shippingrate, setshippingrate] = useState('');
  const [products, setProducts] = useState([]);
  const [salePrice, setSalePrice] = useState(null);
  const [mainImage, setMainImage] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [showDetails, setShowDetails] = useState({
    type: false,
    code: false,
    desc: false,
    shipping: false,
    color: false,
    size: false,
  });

  const toggleSection = (key) => {
    setShowDetails((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    const fetchProductData = async () => {
      const db = getFirestore();
      try {
        const docRef = doc(db, 'products', id);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          console.error("❌ Product not found");
          return;
        }

        const prodData = docSnap.data();
        setProduct({
          id: docSnap.id,
          ...prodData,
          stockStatus: prodData.stockStatus ?? "in", // fallback if missing
        });

        // set default main image
        setMainImage(prodData.productImage);

        const onSaleSnap = await getDocs(collection(db, 'onSale'));
        const onSaleMatch = onSaleSnap.docs.find(
          (doc) => doc.data().productCode === prodData.productCode
        );
        if (onSaleMatch) {
          setSalePrice(onSaleMatch.data().salePrice);
        } else {
          const storeSaleSnap = await getDocs(collection(db, 'storeSale'));
          storeSaleSnap.forEach((saleDoc) => {
            const saleData = saleDoc.data();
            if (
              saleData.categoryId === prodData.productType ||
              saleData.categoryId === prodData.categoryId
            ) {
              const discount =
                (prodData.productPrice * saleData.salePercentage) / 100;
              const discountedPrice = prodData.productPrice - discount;
              setSalePrice(discountedPrice.toFixed(2));
            }
          });
        }
      } catch (error) {
        console.error("❌ Error loading product data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductData();
  }, [id]);

  useEffect(() => {
    const fetchProductsList = async () => {
      const db = getFirestore();
      try {
        const dataCollection = collection(db, 'products');
        const querySnapshot = await getDocs(dataCollection);
        const productList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productList);
      } catch (error) {
        console.error("❌ Error retrieving product list:", error);
      }
    };
    fetchProductsList();
  }, []);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      const db = getFirestore();
      try {
        const siteSnap = await getDocs(collection(db, 'storeDetails'));
        if (!siteSnap.empty) {
          const siteData = siteSnap.docs[0].data();
          setInstaID(siteData.instaID);
          setwhsappID(siteData.phone);
          setcurrency(siteData.currency);
          setshippingrate(siteData.shippingrate);
        }
      } catch (error) {
        console.error("❌ Error fetching site info:", error);
      }
    };
    fetchSiteInfo();
  }, []);

const addToCart = (product) => {
  try {
    // 🚫 Prevent adding if out of stock
    if (product.stockStatus === "out") {
      toast.error("This product is currently out of stock.", {
        position: "bottom-right",
      });
      return;
    }

    const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
    const actualPrice = product.salePrice || product.productPrice;

    const existingProduct = existingCart.find(
      item => item.id === product.id
    );

    const updatedCart = existingProduct
      ? existingCart.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      : [
          ...existingCart,
          {
            id: product.id,
            productName: product.productName,
            productPrice: actualPrice,
            productImage: product.productImage,
            productSize: product.productSize,
            productColor: product.productColor,
            productCode: product.productCode,
            productType: product.productType,
            quantity: 1,
          },
        ];

    localStorage.setItem('cart', JSON.stringify(updatedCart));
    window.dispatchEvent(new Event('toggle-cart'));

    // ✅ Fire Meta AddToCart Event
      if (window.fbq) {
        console.log("Meta AddToCart Fired");
        window.fbq('track', 'AddToCart', {
          content_ids: [product.id],
          content_name: product.productName,
          content_type: 'product',
          value: actualPrice,
          currency: 'PKR'
        });
      }

  } catch (error) {
    console.error('❌ Error adding to cart:', error);
    toast.error('Failed to add to cart.', { position: 'bottom-right' });
  }
};
  const buy_now = (product) => {
    try {
      const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
      const actualPrice = salePrice || product.productPrice;

      // Check if item already exists to avoid duplicates
      const existingProduct = existingCart.find((item) => item.id === product.id);
      let updatedCart;

      if (existingProduct) {
        updatedCart = existingCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        updatedCart = [
          ...existingCart,
          {
            id: product.id,
            productName: product.productName,
            productPrice: actualPrice,
            productImage: product.productImage,
            productSize: product.productSize || "Not Specified",
            productColor: product.productColor || "Not Specified",
            productCode: product.productCode,
            productType: product.productType,
            quantity: quantity,
          },
        ];
      }

      // Save to storage
      localStorage.setItem("cart", JSON.stringify(updatedCart));

      // Optional: If your App uses a Context or Redux for cart state, 
      // you might need to trigger an update here so the CheckoutPage 
      // sees the new item immediately.

      navigate('/checkout');
    } catch (error) {
      console.error("❌ Buy Now failed:", error);
    }
  };
  if (loading) return <p>Loading...</p>;
  if (!product) return <p>No product found</p>;

  const images = [
    product.productImage,
    product.productImage1,
    product.productImage2,
    product.productImage3,
  ].filter(Boolean);
  const isOutOfStock = product.stockStatus === "out";

  return (
    <>

      <Navbar />


      <div className="quick-buy">
        <div className="cover">
          <div className="container">
            <div className="the-product">
              {images.length > 0 && (
                <>
                  <div className="main-image">
                    <img
                      src={mainImage}
                      alt="Main product"
                      style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
                    />
                  </div>
                  <div className="thumbnail-row" style={{ marginTop: "10px" }}>
                    {images
                      ?.filter(img => img && img.trim() !== "")
                      .map((img, idx) => (
                        <img
                          key={idx}
                          src={img}
                          alt={`thumb-${idx}`}
                          onClick={() => setMainImage(img)}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          style={{
                            width: "60px",
                            height: "60px",
                            margin: "5px",
                            cursor: "pointer",
                            border: mainImage === img ? "2px solid black" : "1px solid #ccc",
                            objectFit: "cover",
                          }}
                        />
                      ))}
                  </div>

                </>
              )}
            </div>

            <div className="the-details">
              <p className="title">{product.productName}
              </p>
              <p className="category">{product.categoryId}</p>

              <br />
              <p className="price">
                {salePrice ? (
                  <>
                    <span className="original-price">
                      {currency}.
                      {product.productPrice}
                    </span>
                    <span className="sale-price">
                      {" "}
                      {currency}.
                      {salePrice}
                    </span>
                  </>
                ) : (
                  <> {currency}.{product.productPrice}</>
                )}
              </p>
              <br />
              {products
                .filter((pay) => pay.productCode === product.productCode)
                .map((pay) =>
                  isOutOfStock ? (
                    <div
                      style={{
                        marginTop: "15px",
                        padding: "12px",
                        background: "#fee2e2",
                        color: "#991b1b",
                        borderRadius: "6px",
                        textAlign: "center",
                        fontWeight: "600",
                      }}
                    >
                      ❌ This product is currently Out of Stock
                    </div>
                  ) : (
                    <>
                      <div className='new-devider' >
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          border: '1px solid black',
                          width: 'fit-content'
                        }}>

                          <button
                            onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                            style={{
                              background: 'white',
                              border: 'none',
                              fontSize: '28px',
                              padding: '5px 15px',
                              cursor: 'pointer',
                              color: 'black'
                            }}
                          >
                            -
                          </button>

                          <span style={{ padding: '0 15px', fontWeight: '700' }}>
                            {quantity}
                          </span>

                          <button
                            onClick={() => setQuantity(prev => prev + 1)}
                            style={{
                              background: 'white',
                              border: 'none',
                              fontSize: '22px',
                              padding: '5px 15px',
                              cursor: 'pointer',
                              color: 'black'
                            }}
                          >
                            +
                          </button>

                        </div>
                        <button
                          className="add-to-cart-button2"
                          style={
                            {
                              background: 'white',
                              border: '1px solid black',
                              cursor: 'pointer',
                              color: 'black',

                            }
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            addToCart(product);
                          }}
                        >
                          <p>Add to Cart</p>
                          <i className="fas fa-shopping-cart"></i>
                        </button>
                      </div>

                      <button
                        className="primary-button"
                        onClick={(e) => {
                          e.preventDefault();
                          buy_now(product);
                        }}
                      >
                        <p>Buy Now</p>
                        <i className="fas fa-shopping-bag"></i>
                      </button>
                    </>
                  )
                )}
              <br />

              {/* Details sections (color, size, etc.) */}
              <div className="shopify-box" onClick={() => toggleSection("color")}>
                <div className="shopify-box-inner">
                  <i className="fas fa-palette shopify-icon"></i>
                  <div className="shopify-text">
                    <span className="shopify-label">Color</span>
                    {showDetails.color && (
                      <p className="shopify-value">
                        {product.productColor || "Not Specified yet"}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="shopify-box" onClick={() => toggleSection("size")}>
                <div className="shopify-box-inner">
                  <i className="fas fa-expand shopify-icon"></i>
                  <div className="shopify-text">
                    <span className="shopify-label">Size</span>
                    {showDetails.size && (
                      <p className="shopify-value">
                        {product.productSize || "Not Specified yet"}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="shopify-box" onClick={() => toggleSection("desc")}>
                <div className="shopify-box-inner">
                  <i className="fas fa-align-left shopify-icon"></i>
                  <div className="shopify-text">
                    <span className="shopify-label">Description</span>
                    {showDetails.desc && (
                      <p className="shopify-value">
                        {product.productDescription ||
                          "No description available"}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="shopify-box"
                onClick={() => toggleSection("shipping")}
              >
                <div className="shopify-box-inner">
                  <i className="fas fa-truck shopify-icon"></i>
                  <div className="shopify-text">
                    <span className="shopify-label">Shipping</span>
                    {showDetails.shipping && (
                      <p className="shopify-value">
                        Average Shipping Rate {currency}
                        {shippingrate}, may change based on location.
                      </p>
                    )}
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      <AllProducts />
      <BottomBar />
      <Footer />
    </>
  );
};

export default Product;
